import { NavLink, ThemeIcon } from '@mantine/core';
import { IconBuilding } from '@tabler/icons';
import { AppRoutePaths } from '../../../utils/enums/routes';

interface Props {
  navigate(route: string): void;
}

export function SectorDailyLogsLink({ navigate }: Props) {
  return (
    <NavLink
      styles={{ label: { color: '#373A40' } }}
      label="Funcionários por Setor"
      fw="bold"
      icon={
        <ThemeIcon color="blue" variant="light">
          <IconBuilding size={16} />
        </ThemeIcon>
      }
      onClick={() => navigate(AppRoutePaths.SECTOR_DAILY_LOGS)}
    />
  );
}
